// DottedReveal.jsx
export default function DottedReveal({
    src,
    dotSize = 12,  // diameter of each dot in px
    gap = 12,       // space between dots in px
    overlayColor = "#111", // color of the top layer (what hides the bg)
    className = "",
    style = {},
    children,
    shadowDirection = "to top",       // optional content on top of the dots
  }) {
    const shadowGradient = `linear-gradient(${shadowDirection}, ${overlayColor} 0%, ${overlayColor} 10%, transparent 100%)`;
    const spacing = dotSize + gap;
    const radius = dotSize / 2;
  
    const mask = `radial-gradient(circle ${radius}px, transparent ${radius}px, black ${radius + 1}px)`;
  
    return (
      <>
        <div
          className={className}
          style={{
            position: "relative",
            overflow: "hidden",
            ...style,
          }}
        >
        {/* Animated background container - contains two copies for seamless loop */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            animation: "slideDown 20s linear infinite",
          }}
        >
          {/* First copy of background */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${src})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          />
          {/* Second copy for seamless loop */}
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${src})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          />
        </div>
        {/* The overlay that hides everything except circular holes */}
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            background: overlayColor,
            // mask setup (works in modern browsers)
            maskImage: mask,
            maskSize: `${spacing}px ${spacing}px`,
            maskRepeat: "repeat",
            // Safari/WebKit prefix
            WebkitMaskImage: mask,
            WebkitMaskSize: `${spacing}px ${spacing}px`,
            WebkitMaskRepeat: "repeat",
            zIndex: 1,
          }}
        />
          <div
            style={{
              position: "absolute",
              top: "-1px",
              left: "-20px",
              right: "-20px",
              height: "40rem",
              background: shadowGradient,
              zIndex: 2,
              pointerEvents: "none",
            }}
          />
        {/* Optional content above the dotted layer */}
        <div style={{ position: "relative", zIndex: 3 }}>
          {children}
        </div>
      </div>
      </>
    );
  }
  